import React from 'react';
import PropTypes from 'prop-types';

const AiBadge = ({ status }) => {
  const commonStyle = {
    width: 33,
    height: 33,
    minWidth: 33,
    minHeight: 33,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'white',
    color: '#52CEB7',
    fontSize: '18px',
    fontWeight: 'bold',
    boxShadow: '0 2px 4px rgba(0,0,0,0.25)',
  };

  if (status === 'correct') {
    return (
      <div
        style={{
          ...commonStyle
        }}
      >
        ✓
      </div>
    );
  }

  if (status === 'incorrect') {
    return (
      <div
        style={{
          ...commonStyle
        }}
      >
        —
      </div>
    );
  }

  // Default: render the S3 image
  return (
    <div
      style={{
        ...commonStyle
      }}
    >
      <img
        src="https://yaktack-prod-images.s3.us-west-2.amazonaws.com/yak-tack-logo-papercraft-100.png"
        alt="Yak Tack logo"
        style={{
          width: 25,
          height: 25
        }}
      />
    </div>
  );
};

AiBadge.propTypes = {
  status: PropTypes.oneOf(['default', 'correct', 'incorrect']),
};

AiBadge.defaultProps = {
  status: 'default',
};

export default AiBadge;



// WEBPACK FOOTER //
// ./src/components/tack_ai_chat/ai_badge.jsx